import type { FC } from 'react';

import { SECTION_IDS } from '@/features/home/constants/home.constants';
import type { TrustPoint } from '@/types/home.types';

interface TrustSectionProps {
  points: TrustPoint[];
}

const TrustSection: FC<TrustSectionProps> = ({ points }) => (
  <section id={SECTION_IDS.trust} className="scroll-mt-20 bg-white">
    <div className="mx-auto grid w-full max-w-6xl gap-12 px-5 py-20 md:grid-cols-2 md:px-8">
      <header className="md:sticky md:top-28 md:self-start">
        <h2 className="font-display text-3xl font-extrabold text-[var(--color-ink)] md:text-4xl">
          Lending to a stranger is scary. This isn’t that.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-[var(--color-ink-muted)]">
          Shoutt is built around the one thing a campus already has: people who can be found again
          tomorrow. Everything else exists to make that safe on both sides of the handover.
        </p>
      </header>

      <ul className="flex flex-col gap-5">
        {points.map((point) => (
          <li
            key={point.title}
            className="flex gap-4 rounded-3xl border border-[var(--color-divider)] bg-[var(--color-surface-muted)] p-6"
          >
            <span
              aria-hidden
              className="mt-0.5 inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-[var(--color-success-bg)] text-sm font-bold text-[var(--color-success)]"
            >
              ✓
            </span>
            <div>
              <h3 className="font-display text-base font-bold text-[var(--color-ink)]">
                {point.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-[var(--color-ink-muted)]">
                {point.body}
              </p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default TrustSection;
